import { ExpandAltOutlined, PieChartOutlined, ShoppingCartOutlined } from "@ant-design/icons";
import { NavLink } from "react-router-dom";

export const posMenuItems = [
    {
        key: '1',
        icon: <ShoppingCartOutlined  style={{fontSize: '18px'}} />,
        label: "POS",
        link: '/'
    },
    {
        key: '2',
        icon: <PieChartOutlined style={{fontSize: '18px'}} />,
        label: "Sotuvlar tarixi",
        link: '/history'
    },
    {
        key: '3',
        icon: <PieChartOutlined style={{fontSize: '18px'}} />,
        label: "Mavjud tovarlar",
        link: '/posproducts'
    },
    {
        key: '4',
        icon: <ExpandAltOutlined style={{fontSize: '18px'}} />,
        label: "Xarajatlar",
        link: '/expences'
    },
    {
        key: '5',
        icon: <ExpandAltOutlined style={{fontSize: '18px'}} />,
        label: "Xisobotlar",
        link: '/report'
    },
]